import { ContentSwitcher, ContentSwitcherButton } from '@property.com.au/ui-kit';

type PropertyTypeSwitcherProps = {
  propertyTypes: string[];
  activePropertyType: string;
  setActivePropertyType: (propertyType: string) => void;
};

export const PropertyTypeSwitcher = ({
  propertyTypes,
  activePropertyType,
  setActivePropertyType,
}: PropertyTypeSwitcherProps) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setActivePropertyType(value);
  };

  return (
    <ContentSwitcher id="property-type-switcher" sizeVariant="small" label="Property type switcher">
      {propertyTypes.map((propertyType) => (
        <ContentSwitcherButton
          id={`property-type-${propertyType}`}
          key={`property-type-${propertyType}`}
          value={propertyType}
          label={propertyType}
          onChange={onChange}
          checked={activePropertyType === propertyType}
        />
      ))}
    </ContentSwitcher>
  );
};
